import makeStyles from '@ui/utils/makeStyles';

export default makeStyles()((theme) => ({
  swiper: {
    // Make all slides match the tallest slide (so cards are equal height).
    '& .swiper-wrapper': {
      alignItems: 'stretch',
    },
    '& .swiper-slide': {
      height: 'auto',
      display: 'flex',
    },
  },
  agentCard: {
    marginBottom: theme.spacing(2),
    borderRadius: theme.shape.borderRadius,
    padding: theme.spacing(4, 2),
    // Allow cards to grow to fit testimonial text (no clipping).
    height: '100%',
    minHeight: 400,
    display: 'flex',
    flexDirection: 'column',
    [theme.breakpoints.up('md')]: {
      minHeight: 500
    },
  },
  quoteUserWrapper: {
    flex: 16,
    display: 'flex',
    justifyContent: 'center',
    order: 0,
    paddingTop: theme.spacing(6),
    [theme.breakpoints.up('md')]: {
      order: 2,
      paddingTop: theme.spacing(0),
    },
  },
  quoteAvatar: {
    marginBottom: theme.spacing(2),
    width: 50,
    height: 50,
    [theme.breakpoints.up('md')]: {
      width: 200,
      height: 200,
    },
  },
  quoteTitle1: {
    marginBottom: 0,
    fontSize: 24,
    // Don't hard-cap height; allow wrapping if needed.
    minHeight: 40,
    lineHeight: 1,
    [theme.breakpoints.up('md')]: {
      lineHeight: 1.2,

    },
  },
  quoteTitle2: {
    color: theme.palette.common.black,
    fontFamily: theme.gh_vars.circular,
    fontSize: 16,
    fontWeight: 600,
    marginBottom: theme.spacing(2),
    [theme.breakpoints.up('md')]: {
      fontSize: 18,
      marginBottom: theme.spacing(2),
    },
  },
  quoteText: {
    fontWeight: 'normal',
    lineHeight: 1.6,
    position: 'relative',
    fontSize: 16,
    maxWidth: 275,
    textAlign: 'left',
    [theme.breakpoints.up('md')]: {
      // no fixed height; allow content to define height
    },
  },
  reviewStar: {
    height: 24,
    width: 24,
  }
}));
